/**
 * EDI申込み管理（排出事業者選択ダイアログ専用）
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/edi_requests`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0,
      total_pages: 1
    }
  }
}

const ediRequestEmissionSelect = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: (state) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    index ({ commit }, { request_type, select_emission, emission_request_ids, limit, page }) {
      const api_path = `${API_PATH}`
      const params = {
        request_type: request_type,
        select_emission: (select_emission !== undefined) ? select_emission : false,
        emission_request_ids: (emission_request_ids !== undefined) ? emission_request_ids : [],
        limit: limit,
        page: page
      }
      return new Promise((resolve, reject) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
            let content = data.content
            commit(types.ADMIN_EDI_REQUEST, { content })
            resolve(content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    resetPagination ({ commit }) {
      commit(types.ADMIN_EDI_REQUEST_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.ADMIN_EDI_REQUEST_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.ADMIN_EDI_REQUEST] (state, { content }) {
      state.pagination = content.pagination
    }
  },
}

export default ediRequestEmissionSelect
